import { changeLanguage } from 'i18next';
import { useCallback } from 'react';
import { localStorageKeys } from '../../../app/config/localStorageKeys';
import { SupportedLanguageEnum } from '@clickersphere/core/enums/SupportedLanguageEnum';

export default function useLanguageSelectorController() {
  const handleLanguageChange = useCallback((language: 'pt-BR' | 'en') => {
    changeLanguage(language);
  }, []);

  const cnBase =
    'flex h-10 items-center justify-center rounded-full px-2 sm:h-8';

  const cnSelected = `${cnBase} bg-grey-0 dark:bg-grey-600 text-green-600 dark:text-green-400 font-semibold shadow-md`;

  const cnUnselected = `${cnBase} text-text-tertiary dark:text-text-secondary opacity-60 hover:opacity-100`;

  const selectedLanguage = localStorage.getItem(
    localStorageKeys.LANGUAGE,
  ) as SupportedLanguageEnum;

  return {
    handleLanguageChange,
    selectedLanguage,
    cnSelected,
    cnUnselected,
    dateFormat:
      selectedLanguage === SupportedLanguageEnum['PT-BR']
        ? 'dd/MM/yyyy'
        : 'MM/dd/yyyy',
  };
}
